import { _ } from "../polyglot/polyglot.js";
import { bugfixes, improvements, newFeatures } from "./releaseNotes.js";
import {
	checkIcon,
	fireIcon,
	rocketIcon,
	wrenchIcon,
} from "../elements/icons/icons.js";
import { iconAndText } from "../elements/index.js";
import AccountingDocumentWidget from "../../accounting/shared/documentInfrastructure/AccountingDocumentWidget.js";

/**
 * Widget rendering ReleaseNotes.
 *
 * @param {string} [cssClass] - Extra css class for the release notes
 */
export default class ReleaseNotesDocumentContent extends AccountingDocumentWidget {
	constructor({ cssClass = "" } = {}) {
		super(...arguments);

		this._cssClass = cssClass;
	}

	renderContentOn(html) {
		html.div(
			{ class: ["ReleaseNotesDocumentContent", this._cssClass] },
			this._categoryRenderer({
				title: iconAndText({ icon: rocketIcon }, _("New features")),
				notes: newFeatures,
			}),
			this._categoryRenderer({
				title: iconAndText({ icon: fireIcon }, _("Improvements")),
				notes: improvements,
			}),
			this._categoryRenderer({
				title: iconAndText({ icon: wrenchIcon }, _("Fixes")),
				notes: bugfixes,
			}),
		);
	}

	_categoryRenderer({ title, notes }) {
		if (!notes.length) return (_html) => {};

		return (html) =>
			html.div(
				{ class: "release-note" },
				html.h3({ class: "title" }, title),
				this._notesRenderer(notes),
			);
	}

	_notesRenderer(notes) {
		return (html) =>
			html.ul(...notes.map((note) => this._noteRenderer(note)));
	}

	_noteRenderer(note) {
		return (html) =>
			html.li({ class: "note" }, iconAndText({ icon: checkIcon }, note));
	}
}
